<section class="property-carousel-section">
    <h1>Descubre más Propiedades.</h1>

    <div class="loading-spinner" *ngIf="home.loading$ | async">
        <p-progressSpinner strokeWidth="5" animationDuration=".5s"></p-progressSpinner>
    </div>

    <ng-container *ngIf="(home.latest$ | async) as properties">
        <div class="no-properties" *ngIf="!(home.loading$ | async) && properties.length === 0">
            <p>No se encontraron propiedades por el momento.</p>
        </div>

        <p-carousel
            *ngIf="properties.length > 0"
            [value]="properties"
            [numVisible]="5"
            [numScroll]="3"
            [circular]="true"
            [autoplayInterval]="5000"
            [responsiveOptions]="responsiveOptions"
            styleClass="custom-carousel">
            <ng-template pTemplate="item" let-property>
                <div class="carousel-card">
                    <app-property-card [vm]="property" (select)="openProperty($event)"></app-property-card>
                </div>
            </ng-template>
        </p-carousel>
    </ng-container>
</section>
